<template>
  <div class="standing">
    <div class="operation-bar">
      <!-- search -->
      <search @getSystemList="getSystemList"></search>
      <el-row class="operation-box" style="padding-left:10px;">
        <el-button size="small" icon="el-hg-icon-detail" @click="getDetail">详情</el-button>
        <el-button size="small" type="default" icon="el-hg-icon-add" @click="add" v-permission="'0701'">新增</el-button>
        <el-button size="small" type="primary" icon="el-hg-icon-edit" @click="edit" v-permission="'0702'">修改</el-button>
        <el-button size="small" type="danger" icon="el-hg-icon-delete" @click="delItems" v-permission="'0705'">删除</el-button>
        <el-button size="small" type="success" icon="el-hg-icon-start" @click="startUse" v-permission="'0704'">执行</el-button>
        <el-button type="primary" size="small" icon="el-hg-icon-refreash" @click="refresh">刷新</el-button>
      </el-row>
    </div>
    <!-- list view -->
    <div class="standing-list">
      <list class="list" :dataList.sync="aDataList" @detail="getDetail" />
      <div class="pagination-box">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryParams.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <add :show="bAddShow" @close="bAddShow = false" @refresh="refresh" />
    <edit-dialog :data="oActiveItem" :show="bShowEditDialog" :title.sync="title" :is-edit.sync="isEdit" @close="bShowEditDialog = false" @refresh="refresh" />
    <!-- router -->
    <router-view></router-view>
  </div>
</template>
<script>
import search from './search';
import list from './list';
import add from './actions/add';
import editDialog from './actions/edit';

export default {
  name: 'systemOperation',
  components: {
    search,
    list,
    add,
    editDialog
  },
  data() {
    return {
      queryParams: {
        pageSize: 10,
        currentPage: 1,
        name: ''
      },
      title: '',
      isEdit: false,
      aDataList: [],
      total: 0,
      bAddShow: false,
      oActiveItem: {
        id: 0,
        name: ''
      },
      bShowEditDialog: false
    };
  },
  computed: {
    selected() {
      let ids = [];
      let sysList = [];
      let textInfo = [];
      this.aDataList.forEach(data => {
        if (data.checked) {
          ids.push({
            value: data.id
          });
          textInfo.push(data.name);
          sysList.push(data);
        }
      });
      return {
        ids,
        list: sysList,
        textInfo
      };
    }
  },
  methods: {
    delItems() {
      this.deleteSystem();
    },
    async deleteSystem() {
      if (this.selected.ids.length === 0) {
        this.$toaster.error('请选择至少一个系统');
        return;
      }
      this.$confirm(
        `此操作将永久删除系统<span style="color:red;padding:0 4px;"> ${this.selected.textInfo.join(
          ','
        )} </span>, 是否继续?`,
        '提示',
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.$services
            .postLoading({
              type: 'SYSTEMOPERATION',
              url: 'deleteSystem',
              params: { ids: JSON.stringify(this.selected.ids) }
            })
            .then(res => {
              if (res.code === '000') {
                this.$toaster.ok('删除成功');
                this.refresh();
              }
              else {
                this.$toaster.error(res.msg);
              }
            });
        })
        .catch(() => {});
    },
    edit() {
      if (this.selected.list.length === 0) {
        this.$toaster.error('请选择一个系统');
        return;
      }
      this.title = '系统编辑';
      this.isEdit = true;
      [this.oActiveItem] = this.selected.list;
      this.bShowEditDialog = true;
    },
    getDetail() {
      if (this.selected.list.length === 0) {
        this.$toaster.error('请选择一个系统');
        return;
      }
      this.title = '系统详情';
      this.isEdit = false;
      [this.oActiveItem] = this.selected.list;
      this.bShowEditDialog = true;
    },
    add() {
      this.bAddShow = true;
    },
    async getSystemList(params) {
      if (params) {
        Object.assign(this.queryParams, this.queryParams, params);
      }
      const res = await this.$services.postLoading({
        type: 'SYSTEMOPERATION',
        url: 'getSystemList',
        params: this.queryParams
      });
      res.bean.list.forEach(rep => {
        rep.checked = false;
      });
      this.aDataList = res.bean.list;
      this.total = res.bean.total;
    },
    handleCurrentChange(currentPage) {
      this.queryParams.currentPage = currentPage;
      this.getSystemList();
    },
    handleSizeChange(pageSize) {
      this.queryParams.pageSize = pageSize;
      this.getSystemList();
    },
    refresh() {
      this.getSystemList();
    },
    async updateSystemStatus(state) {
      // state 0：停用，1：启用
      const res = await this.$services.postLoading({
        type: 'SYSTEMOPERATION',
        url: 'updateSystemStatus',
        params: {
          ids: JSON.stringify(this.selected.ids),
          state
        }
      });
      if (res.code === '000') {
        this.$message({
          type: 'success',
          message: state === 0 ? '停用成功' : '启用成功'
        });
        this.refresh();
      }
      else {
        this.$message({
          type: 'error',
          message: state === 0 ? '停用失败' : '启用失败'
        });
      }
    },
    startUse() {
      if (this.selected.ids.length === 0) {
        this.$toaster.error('请选择至少一用户');
        return;
      }
      this.$confirm(
        `此操作将启用<span style="color:red;padding:0 4px;"> ${this.selected.textInfo.join(
          ','
        )} </span>, 是否继续?`,
        '提示',
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.updateSystemStatus(1);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消启用'
          });
        });
    },
    stopUse() {
      if (this.selected.ids.length === 0) {
        this.$toaster.error('请选择至少一用户');
        return;
      }
      this.$confirm(
        `此操作将停用<span style="color:red;padding:0 4px;"> ${this.selected.textInfo.join(
          ','
        )} </span>, 是否继续?`,
        '提示',
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.updateSystemStatus(0);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消停用'
          });
        });
    }
  },
  created() {
    this.getSystemList();
  }
};
</script>
<style lang="scss" scoped>
.pagination-box {
  text-align: center;
}

/*.operation-box{*/
/*padding:10px;*/
/*background: #F1F9FB;*/
/*}*/
</style>
